import { GET_POSTED_NOTE_SUCCESS } from './postedNote.types';

const initialState = {
    // The currently-loaded client's posted note, or null when none exists.
    postedNote: null,
};

export const postedNoteReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_POSTED_NOTE_SUCCESS:
            return {
                ...state,
                postedNote: action.payload,
            };
        default:
            return state;
    }
};
